export default __webpack_public_path__ + "media/siteware/favicon-128-3d49dadf36a7c72bfd3acfd626a79720.png";